/* TryAgain homepage mechanics — ported from approved prototype (assets/demo/index.html).
   Desktop: pinned scroll scenes (parade, color morph, features, jacket scrub) + cursor focus.
   Mobile (≤768px): no pins — static hero, tap-driven morph/accordion, looping jacket video.
   Requires gsap + ScrollTrigger (loaded via CDN before this file, all deferred). */
(function () {
  'use strict';

  function init() {
    if (!document.querySelector('.parade') || typeof gsap === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = matchMedia('(max-width: 768px)').matches;

    if (reduced) {
      // static final states, no pins/scrubs (CSS already shows figures/tags/cta)
      document.querySelectorAll('.acc .acc-item .acc-body').forEach(function (b, i) {
        if (i > 0) { b.style.height = '0'; b.style.opacity = '0'; }
      });
      return;
    }

    var figs = gsap.utils.toArray('.stage .p');

    /* ---------- shared: morph config ---------- */
    var morphEl = document.getElementById('morph');
    var cfgEl = morphEl && morphEl.querySelector('[data-ta-morph-config]');
    var ways = cfgEl ? JSON.parse(cfgEl.textContent) : [];
    var layers = gsap.utils.toArray('.morph-stage img.layer');
    var cname = document.getElementById('cname');
    var swatches = gsap.utils.toArray('.morph .swatch');

    function applyWayLabels(idx) {
      if (cname) cname.textContent = ways[idx].name;
      swatches.forEach(function (s, k) { s.classList.toggle('on', k === idx); });
      document.documentElement.style.setProperty('--ta-bg', ways[idx].bg);
    }

    /* ---------- shared: features accordion ---------- */
    var lpImgs = gsap.utils.toArray('.lineup-stage img');
    var accItems = gsap.utils.toArray('#acc .acc-item');
    var lpActive = 0;
    if (accItems.length && !isMobile) gsap.set(accItems[0].querySelector('.acc-body'), { height: 'auto', opacity: 1 });

    function lpSet(i) {
      if (i === lpActive) return;
      if (isMobile) {
        // class-only toggle — GSAP height/transform tweens jank on phones
        lpImgs[lpActive].classList.remove('on');
        lpImgs[i].classList.add('on');
        accItems[lpActive].classList.remove('on');
        accItems[i].classList.add('on');
        lpActive = i;
        return;
      }
      gsap.to(lpImgs[lpActive], { opacity: 0, scale: 1.06, rotation: 2, duration: .45, overwrite: 'auto' });
      gsap.fromTo(lpImgs[i], { opacity: 0, scale: .9, rotation: -3 }, { opacity: 1, scale: 1, rotation: 0, duration: .55, overwrite: 'auto' });
      accItems[lpActive].classList.remove('on');
      gsap.to(accItems[lpActive].querySelector('.acc-body'), { height: 0, opacity: 0, duration: .4, overwrite: 'auto' });
      accItems[i].classList.add('on');
      gsap.to(accItems[i].querySelector('.acc-body'), { height: 'auto', opacity: 1, duration: .5, overwrite: 'auto' });
      lpActive = i;
    }

    /* ---------- shared: idle breathing ---------- */
    figs.forEach(function (el, i) {
      gsap.to(el, { y: '+=7', duration: 3 + (i % 5) * .5, delay: (i % 7) * .4, ease: 'sine.inOut', repeat: -1, yoyo: true });
    });

    /* ---------- shared: product cards reveal ---------- */
    gsap.utils.toArray('.pcard').forEach(function (card, i) {
      gsap.from(card, { y: 70, opacity: 0, duration: .8, ease: 'power2.out',
        scrollTrigger: { trigger: card, start: 'top 88%' }, delay: (i % 3) * .07 });
    });

    var unzipframe = document.getElementById('unzipframe');

    /* ================= MOBILE: calm, tap-driven ================= */
    if (isMobile) {
      // hero: figures visible & sharp (CSS), gentle entrance
      gsap.set('.stage .p', { x: 0, y: 0, scale: 1, opacity: 1 });
      gsap.set('.row-back .p img', { filter: 'none' });
      gsap.from('.row-back .p', { opacity: 0, y: 24, duration: .7, stagger: .12, ease: 'power2.out' });

      // color morph: tap a swatch to re-dress the set
      if (morphEl && ways.length) {
        applyWayLabels(0);
        swatches.forEach(function (s, k) {
          s.addEventListener('click', function () {
            layers.forEach(function (l, li) {
              gsap.to(l, { opacity: li === k - 1 ? 1 : 0, duration: .5, overwrite: 'auto' });
            });
            gsap.to('body', { backgroundColor: ways[k].bg, duration: .5 });
            applyWayLabels(k);
          });
        });
      }

      // features: tap accordion heads
      accItems.forEach(function (item, i) {
        item.querySelector('.acc-head').addEventListener('click', function () { lpSet(i); });
      });

      // jacket: lightweight looping unzip video instead of scroll scrub
      if (unzipframe && unzipframe.dataset.video) {
        var v = document.createElement('video');
        v.src = unzipframe.dataset.video;
        v.muted = true; v.loop = true; v.autoplay = true;
        v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
        v.className = 'poster';
        v.poster = unzipframe.src;
        unzipframe.replaceWith(v);
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      return;
    }

    /* ================= DESKTOP: pinned scenes ================= */

    /* ---------- hero parade ---------- */
    figs.forEach(function (el) {
      var e = el.dataset.e;
      if (e === 'left') gsap.set(el, { x: '-46vw' });
      if (e === 'right') gsap.set(el, { x: '46vw' });
      if (e === 'rise') gsap.set(el, { y: '42vh' });
      if (e === 'depth') gsap.set(el, { scale: .72, transformOrigin: 'bottom center' });
    });

    var par = gsap.timeline({
      scrollTrigger: { trigger: '#parade', start: 'top top', end: '+=5200', scrub: 0.35, pin: true }
    });
    par.to('#paradehead p, #paradehead .scrollhint', { opacity: 0, duration: .4 }, 0)
       .to('#paradehead h1', { scale: .84, yPercent: -160, duration: 3.6, ease: 'none' }, .4);

    var order = [].concat(
      gsap.utils.toArray('.row-back .p'),
      gsap.utils.toArray('.row-mid .p'),
      gsap.utils.toArray('.row-front .p')
    );
    order.forEach(function (el, i) {
      par.to(el, { x: 0, y: 0, scale: 1, opacity: 1, duration: .55, ease: 'power2.out' }, .35 + i * .24);
    });
    par.to('.row-front', { yPercent: 5, ease: 'none', duration: 4.6 }, 0)
       .to('.row-back', { yPercent: -4, ease: 'none', duration: 4.6 }, 0);

    // focus: scroll wakes the girls one by one; the cursor also sharpens whoever is near.
    // effective blur = min(scroll baseline, cursor distance blur)
    var backImgs = gsap.utils.toArray('.row-back .p img');
    var focusStates = backImgs.map(function () { return { base: 3, cursor: 3 }; });
    var applyFocus = function (i) {
      var blur = Math.min(focusStates[i].base, focusStates[i].cursor);
      var f = blur / 3; // 1 = fully blurred, 0 = sharp
      gsap.to(backImgs[i], {
        filter: 'blur(' + blur.toFixed(2) + 'px) saturate(' + (.96 + .04 * (1 - f)).toFixed(3) + ') brightness(' + (1 + .01 * f).toFixed(3) + ')',
        duration: .35, ease: 'power2.out', overwrite: 'auto'
      });
    };
    backImgs.forEach(function (img, i) {
      par.to(focusStates[i], { base: 0, duration: .45, ease: 'none',
        onUpdate: function () { applyFocus(i); } }, 2.0 + i * .35);
    });
    if (matchMedia('(hover:hover)').matches) {
      var raf = null;
      document.getElementById('parade').addEventListener('mousemove', function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var radius = innerWidth * 0.16;
          backImgs.forEach(function (img, i) {
            var r = img.getBoundingClientRect();
            var d = Math.hypot(e.clientX - (r.left + r.width / 2), e.clientY - (r.top + r.height / 2));
            focusStates[i].cursor = 3 * Math.min(1, d / radius); // 0 close -> sharp
            applyFocus(i);
          });
        });
      });
    }
    par.to('.stage .tag', { opacity: 1, duration: .4, stagger: .12 }, 4.35)
       .to('#paradecta', { opacity: 1, duration: .5 }, 4.7);

    /* ---------- color morph (pinned scrub) ---------- */
    if (morphEl && ways.length) {
      var morphTl = gsap.timeline({
        scrollTrigger: {
          trigger: '#morph', start: 'top top', end: '+=3200', scrub: 0.4, pin: true,
          onUpdate: function (self) {
            var idx = Math.min(ways.length - 1, Math.round(self.progress * (ways.length - 1)));
            applyWayLabels(idx);
          },
          onLeave: function () { gsap.to('body', { backgroundColor: ways[0].bg, duration: .6 }); document.documentElement.style.setProperty('--ta-bg', ways[0].bg); },
          onLeaveBack: function () { gsap.to('body', { backgroundColor: ways[0].bg, duration: .4 }); document.documentElement.style.setProperty('--ta-bg', ways[0].bg); }
        }
      });
      ways.slice(1).forEach(function (w, i) {
        morphTl.to(layers[i], { opacity: 1, duration: 1 }, i)
               .to('body', { backgroundColor: w.bg, duration: 1 }, i);
      });
    }

    /* ---------- features morph (pinned scrub) ---------- */
    if (lpImgs.length && accItems.length) {
      ScrollTrigger.create({
        trigger: '#lineup', start: 'top top', end: '+=3200', scrub: true, pin: true,
        onUpdate: function (self) { lpSet(Math.min(lpImgs.length - 1, Math.floor(self.progress * lpImgs.length))); }
      });
    }

    /* ---------- jacket: scroll-scrubbed unzip film ---------- */
    if (unzipframe) {
      var UFRAMES = parseInt(unzipframe.dataset.frames, 10) || 60;
      var base = unzipframe.dataset.frameBase; // .../ta-u-01.webp?v=123
      var uimgs = [];
      var preloaded = false;
      var preload = function () {
        if (preloaded) return;
        preloaded = true;
        for (var i = 1; i <= UFRAMES; i++) {
          var im = new Image();
          im.src = base.replace('u-01', 'u-' + String(i).padStart(2, '0'));
          uimgs.push(im);
        }
      };
      // start fetching frames only when the section is approaching
      ScrollTrigger.create({ trigger: '.jacket', start: 'top 300%', once: true, onEnter: preload });
      ScrollTrigger.create({
        trigger: '.jacket', start: 'top top', end: '+=2600', scrub: 0.3, pin: true,
        onUpdate: function (self) {
          if (!preloaded) preload();
          var i = Math.round(self.progress * (UFRAMES - 1));
          if (uimgs[i] && uimgs[i].complete) unzipframe.src = uimgs[i].src;
        }
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // theme editor: re-run cleanly when sections are re-rendered
  document.addEventListener('shopify:section:load', function () { location.reload(); });
})();
